export default "__VITE_ASSET__0E8MYIrX__"